import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {ScartiConsuntivoVolumiModel} from '../../../../models/ScartiConsuntivoVolumiModel';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {Subscription} from 'rxjs';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ConsuntivoVolumiScartoService} from '../service-consuntivo-volumi-scarto/consuntivo-volumi-scarto.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as toastr from 'toastr';
import {HttpHeaders} from '@angular/common/http';
import {Offset} from '../../../../models/Offset';
import { saveAs } from 'file-saver';
import * as FileSaver from 'file-saver';
import {MatDialog} from '@angular/material';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';

@Component({
  selector: 'app-filter-consuntivo-volumi-scarto',
  templateUrl: './filter-consuntivo-volumi-scarto.component.html',
  styleUrls: ['./filter-consuntivo-volumi-scarto.component.scss']
})
export class FilterConsuntivoVolumiScartoComponent extends ProjectConstants implements OnInit, OnDestroy {

  @ViewChild(NumAnnoMeseFilterComponent) numAnnoFilterComponent;

  @Input() reportSection?: boolean;
  @Input() numAnnoMese?: number;
  @Input() numAnnoMeseData?: number;
  @Output() dataFiltered = new EventEmitter<any>();

  regionCod: string;
  localCustomerCod: string;
  resourceUnitCod: string;
  designCod: string;
  contractTypeCod: string;
  shareName: string;
  applicationDescription: string;
  providerCod: string;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  filter: ScartiConsuntivoVolumiModel;
  intermittentBool: boolean;

  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/csv',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    }),
    responseType: 'application/csv'
  };

  constructor(private loaderService: LoaderService,
              private consuntivoVolumiScartoService: ConsuntivoVolumiScartoService,
              private sanitizer: DomSanitizer,
              private dialog: MatDialog) {
    super();
    this.numAnnoMese = null;
    this.regionCod = null;
    this.localCustomerCod = null;
    this.resourceUnitCod = null;
    this.designCod = null;
    this.contractTypeCod = null;
    this.shareName = null;
    this.applicationDescription = null;
    this.providerCod = null;
  }

  ngOnInit() {
    this.filter = new ScartiConsuntivoVolumiModel();
    this.offset = new Offset(10, 0);
  }


  filterTable(): void {
    this.loaderService.display(true);
    this.getAllFilters();
    this.dataFiltered.emit(this.filter);
  }

  resetTable() {
    this.numAnnoFilterComponent.reset();
    this.localCustomerCod = null;
    this.regionCod = null;
    this.resourceUnitCod = null;
    this.contractTypeCod = null;
    this.designCod = null;
    this.shareName = null;
    this.applicationDescription = null;
    this.providerCod = null;

    this.filterTable();
  }

  ngOnDestroy(): void {
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.consuntivoVolumiScartoService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.consuntivoVolumiScartoService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }
  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUNTIVO_VOLUMI_SCARTO}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }
    this.filter.localCustomerCod = this.localCustomerCod ? this.localCustomerCod : '';
    this.filter.regionCod = this.regionCod ? this.regionCod : '';
    this.filter.resourcesUnitCod = this.resourceUnitCod ? this.resourceUnitCod : '';
    this.filter.contractCod = this.contractTypeCod ? this.contractTypeCod : '';
    this.filter.designCod = this.designCod ? this.designCod : '';
    this.filter.shareName = this.shareName ? this.shareName : '';
    this.filter.applicationDescription = this.applicationDescription ? this.applicationDescription : '';
    this.filter.providerCod = this.providerCod ? this.providerCod : '';
    this.loaderService.display(false);
  }

}
